// js/custom-element/ui/native-video.js
if (!customElements.get('native-video')) {
  var NativeVideo = class extends HTMLElement {
    /**
     * This must be done in the constructor and not connectedCallback because the element will be re-added
     * at run-time by Flickity
     */
    constructor() {
      super();
      this.hasLoaded = false;
      if (this.autoPlay) {
        this.play();
      } else {
        this.addEventListener('click', this.play.bind(this), { once: true });
      }
    }
    get autoPlay() {
      return this.hasAttribute('autoplay');
    }
    play() {
      if (!this.hasLoaded) {
        this._replaceContent();
      }
      this.querySelector('video').play();
    }
    pause() {
      if (this.hasLoaded) {
        this.querySelector('video').pause();
      }
    }
    _replaceContent() {
      let node = this.querySelector('template');
      if (!node) {
        return;
      }
      node = node.content.firstElementChild.cloneNode(true);
      if (!this.hasAttribute('autoplay')) {
        this.innerHTML = '';
      }
      this.appendChild(node);
      this.firstElementChild.addEventListener('play', () => {
        this.dispatchEvent(new CustomEvent('video:played', { bubbles: true }));
      });
      this.firstElementChild.addEventListener('pause', () => {
        this.dispatchEvent(new CustomEvent('video:paused', { bubbles: true }));
      });
      this.hasLoaded = true;
    }
  };
  window.customElements.define('native-video', NativeVideo);
}
